import { z } from "zod";

export const GetCampaignFunctionCountResponseBodySchema = z.object({
  count: z.number(),
});
export type GetCampaignFunctionCountResponseBodyType = z.infer<
  typeof GetCampaignFunctionCountResponseBodySchema
>;
